import { CAT_NECESSARY, CAT_ANALYTICS } from "../constants";

const translation = {
  consentModal: {
    title: "Njoftim për biskotat",
    description:
      "Ne përdorim biskota të nevojshme për të siguruar që kjo faqe interneti funksionon si duhet. Ne gjithashtu përdorim biskota opsionale për ndjekje që na ndihmojnë të kuptojmë se si ndërveproni me faqen tonë. Këto biskota opsionale do të vendosen vetëm me miratimin tuaj.",
    acceptAllBtn: "Prano të gjitha",
    acceptNecessaryBtn: "Refuzo të gjitha",
    showPreferencesBtn: "Menaxho preferencat individuale",
  },
  preferencesModal: {
    title: "Menaxho preferencat e biskotave",
    acceptAllBtn: "Prano të gjitha",
    acceptNecessaryBtn: "Refuzo të gjitha",
    savePreferencesBtn: "Prano zgjedhjen aktuale",
    closeIconLabel: "Mbyll dritaren",
    sections: [
      {
        title: "Përdorimi i biskotave",
        description:
          "Ne përdorim biskota për të mbështetur funksionet thelbësore të kësaj faqe interneti dhe për të përmirësuar përvojën tuaj të shfletimit.",
      },
      {
        title: "Biskota Striktësisht të Nevojshme",
        description:
          "Këto biskota janë thelbësore për funksionimin e duhur të faqes së internetit, për shembull për autentikimin e përdoruesit.",
        linkedCategory: CAT_NECESSARY,
        cookieTable: {
          headers: { name: "Emri", domain: "Shërbimi", description: "Përshkrimi", expiration: "Skadimi" },
          body: [
            {
              name: "_care_leavers_social_hub_session",
              domain: "www.secure-messaging.co.uk",
              description: "Biskotë vendosur nga Platforma Digjitale e Komunitetit për autentikimin e përdoruesit.",
              expiration: "Sesioni",
            },
            {
              name: "CSRF-TOKEN",
              domain: "www.secure-messaging.co.uk",
              description: "Biskotë vendosur nga Platforma Digjitale e Komunitetit për autentikimin e përdoruesit",
              expiration: "Sesioni",
            },
            {
              name: "__cf_bm",
              domain: ".www.secure-messaging.co.uk",
              description:
                "Kjo biskotë përdoret për të dalluar midis njerëzve dhe robotëve për të mbrojtur faqen nga keqpërdorimi automatizuar. Të dhëna personale nuk mblidhen.",
              expiration: "30 minuta",
            },
          ],
        },
      },
      {
        title: "Analitika",
        description:
          "Biskotat e përdorura për analitikën ndihmojnë në mbledhjen e të dhënave që u lejojnë shërbimeve të kuptojnë se si përdoruesit ndërveprojnë me një shërbim të veçantë. Këto të dhëna mundësojnë përmirësimin e përmbajtjes dhe ndërtimin e veçorive më të mira për përvojën e përdoruesit.",
        linkedCategory: CAT_ANALYTICS,
        cookieTable: {
          headers: { name: "Emri", domain: "Shërbimi", description: "Përshkrimi", expiration: "Skadimi" },
          body: [
            {
              name: "_ga",
              domain: "Google Analytics",
              description:
                'Biskotë vendosur nga <a href="https://business.safety.google/adscookies/">Google Analytics</a>',
              expiration: "Skadon pas 12 ditësh",
            },
            {
              name: "_gid",
              domain: "Google Analytics",
              description:
                'Biskotë vendosur nga <a href="https://business.safety.google/adscookies/">Google Analytics</a>',
              expiration: "Sesioni",
            },
          ],
        },
      },
    ],
  },
};

const servicesLabel = "Mundëson ruajtjen e lidhur me analitikën, p.sh. kohëzgjatjen e vizitës.";

export { translation, servicesLabel };
